<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="content"></a><a id="page_3">CONTENTS</a></h2><a id="page_3">
</a><p class="cont1"><a id="page_3"></a><a class="nounder" href="#/xhtml/introd">Introduction</a></p>
<p class="cont1"><a class="nounder" href="#/xhtml/ch01">Chapter 1:</a></p>
<p class="conta"><a class="nounder" href="#/xhtml/ch01"><strong>STOCKS: THE FOUNDATION</strong></a></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">Chapter 2</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample"><strong>CLEAR BROTH–BASED SOUPS</strong></span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">Chapter 3</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample"><strong>FISH AND SEAFOOD SOUP/STEWS</strong></span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample"><strong>POTAGES, PURÉES, AND CREAMY BISQUES</strong></span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample"><strong>PANADES</strong></span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample"><strong>BEAN SOUPS</strong></span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample"><strong>HEARTY SOUPS</strong></span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample"><strong>CHOWDERS</strong></span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="conta"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample"><strong>CHILLED SOUPS</strong></span></p>
<p class="cont2"><span class="nounder" href="#/xhtml/app01" title="Link target outside of Sample">Appendix of Additional Techniques</span></p>
<p class="contc"><span class="nounder" href="#/xhtml/resources" title="Link target outside of Sample">Resources</span></p>
<p class="contc"><span class="nounder" href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="contc"><span class="nounder" href="#/xhtml/about" title="Link target outside of Sample">About the Author</span></p>
<p class="contc"><span class="nounder" href="#/xhtml/photo" title="Link target outside of Sample">About the Photographer</span></p>
<p class="contc"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?3d55ffac